import { Injectable } from "@angular/core";
import { LgApplicationPermissionsBase } from "@logex/framework/lg-application";

@Injectable({ providedIn: "root" })
export class ApplicationPermissions extends LgApplicationPermissionsBase {
    static readonly ADMIN = "acm_admin";
    static readonly INTERNAL = "internal";
    static readonly VIEW_ALL_SPECIALISMS = "acm_view_all_specialisms";
    static readonly VIEW_ALL_DIAGNOSIS_GROUPS = "acm_view_all_diagnosis_groups";
    static readonly PRACTICE_VARIATION_ACCESS = "acm_practice_variation_access";
    static readonly PROCESS_VARIATION_ACCESS = "acm_process_variation_access";
    static readonly BEST_PRACTICES_ACCESS = "acm_best_practice_access";
    static readonly BEST_PRACTICES_EDIT = "acm_best_practice_edit";
    static readonly MONITORING_ACCESS = "acm_monitoring_access";
    static readonly KPI_ACCESS = "acm_kpi_access";
    static readonly MONITORING_EDIT = "acm_monitoring_edit";
    static readonly EXCLUSION_RULES = "acm_exclusion_rules";
    static readonly SCENARIO_ACCESS = "acm_open";
    static readonly COSTING_SETTINGS_EDIT = "acm_costing_settings_edit";

    constructor() {
        super();

        (this as any).InternalRole = ApplicationPermissions.INTERNAL;
    }
}
